import type {
  SetLineItemCalculationStateResponse,
  SetLineItemCalculationStateRequestPayload,
} from '@vy/api-definition';
import { SetLineItemCalculationStateResponseSchema } from '@vy/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useQueryClient, useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import { invalidateInvoicesQueries } from '../../utils/query-invalidation';

export function useSetLineItemCalculationState(
  lineItemId: string,
  options?: UseMutationOptions<
    SetLineItemCalculationStateResponse,
    unknown,
    SetLineItemCalculationStateRequestPayload
  >,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ disable }) => {
      const lineItemsApi = getPrivateApi();

      const setLineItemCalculationStateResponse = await lineItemsApi.setLineItemCalculationState({
        lineItemId,
        setLineItemCalculationStateRequest: { disable },
      });

      return SetLineItemCalculationStateResponseSchema.parse(setLineItemCalculationStateResponse);
    },
    ...options,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries(queryKeys.dynamicInvoice()),
        invalidateInvoicesQueries(queryClient),
      ]);
    },
  });
}
